import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 16px;
`;

export const SwitchLabel = styled.span`
  margin-bottom: 0.75rem;

  font-size: 17px;
  color: #7f8996;
`;

export const InputLabel = styled.span`
  margin-bottom: 2px;

  font-size: 17px;
  color: #7f8996;
`;

export const Button = styled.button`
  align-self: center;

  margin: 4px 0;
  padding: 9px 32px;

  font-size: 17px;
  color: white;

  background-color: #2091ea;

  border: none;
  border-radius: 4px;

  cursor: pointer;

  transition: opacity 0.2s;

  &:hover {
    opacity: 0.95;
  }

  &:disabled {
    background-color: #7f8996;
  }
`;
